import styled from 'styled-components'

import { Color, MediaBreakpoint } from 'root-constants'

import {
  PrimaryButton,
  bodyTextStyles,
  narrowContentStyles,
} from '../../CookieConsentShared.styles'

export const StyledCookieConsentBanner = {
  BannerBar: styled.div`
    width: 100%;

    border-top: 1px solid ${Color.SKY_LIGHT};
    background: ${Color.WHITE};

    pointer-events: auto;
  `,
  BannerLayout: styled.div`
    ${narrowContentStyles}

    display: flex;
    flex-direction: column;

    padding: 16px;

    @media (min-width: ${MediaBreakpoint.LAPTOP}px) {
      width: 100%;
      max-width: 100%;

      flex-direction: row;
      align-items: center;

      padding: 16px 40px;
    }
  `,
  BannerCopy: styled.div`
    margin-bottom: 16px;

    @media (min-width: ${MediaBreakpoint.LAPTOP}px) {
      flex: 1;

      margin-right: 40px;
      margin-bottom: 0;
    }
  `,
  BannerTitle: styled.h2`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.INK_DARKEST};

    margin-bottom: 8px;
  `,
  BannerText: styled.p`
    ${bodyTextStyles}

    a {
      color: inherit;
      text-decoration: underline;
    }
  `,
  BannerLink: styled.button`
    width: 100%;
    min-height: 16px;
    align-self: center;

    padding: 0;
    border: 0;

    background: transparent;

    color: ${Color.INK_DARKER};
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;

    cursor: pointer;

    @media (min-width: ${MediaBreakpoint.LAPTOP}px) {
      width: auto;
      align-self: auto;
      text-align: left;
    }
  `,
  BannerActions: styled.div`
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 24px;

    @media (min-width: ${MediaBreakpoint.LAPTOP}px) {
      flex-direction: row;
      align-items: center;
    }
  `,
  PrimaryButton,
}
